const paywayList = [
  { id: "wxpay", name: "微信支付" },
  { id: "balance", name: "余额支付" },
  { id: "cash", name: "现金支付" },
  { id: "single_wxpay", name: "微信免签" },
  { id: "single_alipay", name: "支付宝免签" },
  { id: "unionpay", name: "银联支付" },
  { id: "card_balance", name: "加油卡支付" },
  { id: "allinpay", name: "通联支付" },
  { id: "family_balance", name: "亲属卡支付" },
  { id: "team_balance", name: "车队卡支付" },
  { id: "alipay", name: "支付宝支付" },
  { id: "scan", name: "扫码支付" },
  { id: "pos", name: "刷卡支付" },
  { id: "fuiou", name: "支付宝付" },
  { id: "normal_allinpay", name: "聚合支付" },
  { id: "lakala", name: "快捷支付" },
  { id: "leshua", name: "乐付" },
];
export default paywayList;
